var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTariff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 410 410",
    style: {
      enableBackground: "new 0 0 410 410"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FF6C37;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.9,134c-8.6-7-18.3-11.5-28-13.6V106c0-7.4-6-13.3-13.3-13.3c-7.4,0-13.3,6-13.3,13.3v14.3 c-14.2,3.1-27.2,11.6-33.8,25.5c-6.8,14.4-6.4,29.2,2.1,42.4c7.9,12.2,21.8,21.5,39,28.6c15.7,6.5,24.1,13.4,28,19.4 c3.4,5.3,4.1,10.9,1.5,18c-2.4,6.4-9.5,11.3-21.5,11.7c-11.9,0.4-24.8-4-32.8-11.7c-5.3-5.1-13.7-4.9-18.8,0.4 c-5.1,5.3-4.9,13.7,0.4,18.8c9.8,9.4,22.8,15.4,36,17.8V304c0,7.4,6,13.3,13.3,13.3s13.3-6,13.3-13.3v-12.7 c14.7-3,29-11.4,35.1-27.9c5.3-14.2,4.4-28.7-4.1-41.8c-8-12.4-22-22-40.1-29.5c-15-6.2-23.2-12.8-26.9-18.5 c-3-4.7-3.6-9.7-0.4-16.5c2.6-5.6,9-10.2,18.3-11.4c9.2-1.1,20,1.4,29.2,8.9c5.7,4.6,14.1,3.8,18.7-1.9 C214.5,147.1,213.6,138.7,207.9,134L207.9,134z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.8,334c0,30,24.3,54.3,54.3,54.3h189.1c30,0,54.3-24.3,54.3-54.3V76c0-30-24.3-54.3-54.3-54.3H71.1 c-30,0-54.3,24.3-54.3,54.3L16.8,334z M71.1,361.6c-15.3,0-27.6-12.4-27.6-27.6V76c0-15.3,12.4-27.6,27.6-27.6l189.1,0 c15.3,0,27.6,12.4,27.6,27.6v258c0,15.3-12.4,27.6-27.6,27.6H71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.9,151.8c0-18.7-15.1-33.8-33.8-33.8h-18.8c-7.4,0-13.3,6-13.3,13.3c0,7.4,6,13.3,13.3,13.3h18.8 c4,0,7.2,3.2,7.2,7.2v164.1c0,4-3.2,7.2-7.2,7.2h-18.8c-7.4,0-13.3,6-13.3,13.3s6,13.3,13.3,13.3h18.8c18.7,0,33.8-15.1,33.8-33.8 V151.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariff);
export default __webpack_public_path__ + "static/media/tariff.49022f4c2b80fb296bc07c08e7b2ace7.svg";
export { ForwardRef as ReactComponent };